/**
 * Resolves the Mapbox access token from whichever runtime env the consumer
 * uses (Vite → `VITE_MAPBOX_API_KEY`, Next.js → `NEXT_PUBLIC_MAPBOX_TOKEN`).
 * Both packages historically read these from `import.meta.env` /
 * `process.env` directly — centralizing here lets the adapter implementations
 * stay framework-agnostic.
 *
 * Returns an empty string if no token is configured. Adapters bail out early
 * (and log once) rather than crashing the host page.
 */

export function getMapboxToken(): string {
  // Vite (admin frontend)
  try {
    // @ts-ignore — import.meta.env only exists under Vite
    const viteToken = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_MAPBOX_API_KEY : undefined;
    if (viteToken) return viteToken as string;
  } catch {
    // import.meta unavailable (Next.js node context) — fall through
  }

  // Next.js (public website)
  if (typeof process !== 'undefined' && process.env) {
    const nextToken = process.env.NEXT_PUBLIC_MAPBOX_TOKEN;
    if (nextToken) return nextToken;
  }

  return '';
}
